module.exports = __webpack_public_path__ + "static/media/rober9.688c64aa.jpg";